module.exports = __webpack_public_path__ + "img/legacy-web-shape.694131d3.png";